module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_marmita.2ea685c4.png";